import React from "react";

import { faBuilding } from "@fortawesome/pro-solid-svg-icons/faBuilding";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Company } from "@mapmycustomers/shared/types/entity";

import { PhoneNumber } from "../field";

import styles from "./CompanyName.module.scss";

interface Props {
  company: Company;
}

const CompanyName: React.FC<Props> = ({ company }) => (
  <div className={styles.container}>
    <div className={styles.iconContainer}>
      <FontAwesomeIcon icon={faBuilding} />
    </div>
    <div className={styles.details}>
      <div className={styles.name}>{company.name}</div>
      <PhoneNumber className={styles.phoneNumber} value={company.phone} />
    </div>
  </div>
);

export default CompanyName;
